// initial state
import router from '../../router'

const state = {
  globalDialogIsOpen: false,
  snackbar: {
    message: "",
    isOpen: false,
    color: 'info',
    timeout: 5000,
  },
}

// getters
const getters = {
}

// actions
const actions = {
  navigateTo({ commit }, routeName) {
    router.push({ name: routeName })
  },
  showSnackbarSuccess({ commit }, payload) {
    commit('setSnackbarMessage', payload.message)
    commit('setSnackbarColor', 'success')
    commit('showSnackbar')
  },
  showSnackbarError({ commit }, payload) {
    commit('setSnackbarMessage', payload.message)
    commit('setSnackbarColor', 'error')
    commit('showSnackbar')
  },
  showSnackbarInfo({ commit }, payload) {
    commit('setSnackbarMessage', payload.message)
    commit('setSnackbarColor', 'info')
    commit('showSnackbar')
  },
  hideSnackbar({ commit }) {
    commit('hideSnackbar')
  },

  openGlobalDialog ({ commit }) {
    commit('setGlobalDialogOpen')
  },

  closeGlobalDialog ({ commit }) {
    commit('setGlobalDialogClosed')
  },
}

// mutations
const mutations = {
  setSnackbarMessage (state, message) {
    state.snackbar.message = message
  },
  setSnackbarColor (state, color) {
    state.snackbar.color = color
  },
  showSnackbar (state) {
    state.snackbar.isOpen = true
  },
  hideSnackbar (state) {
    state.snackbar.isOpen = false
  },

  setGlobalDialogOpen (state) {
    state.globalDialogIsOpen = true
  },

  setGlobalDialogClosed (state) {
    state.globalDialogIsOpen = false
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
